import { render, staticRenderFns } from "./Double.vue?vue&type=template&id=6203da44&scoped=true&"
import script from "./Double.vue?vue&type=script&lang=js&"
export * from "./Double.vue?vue&type=script&lang=js&"
import style0 from "./Double.vue?vue&type=style&index=0&id=6203da44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203da44",
  null
  
)

export default component.exports